import _extends from 'babel-runtime/helpers/extends';

import isStringOrStringArray from '@/utils/isStringOrStringArray';

export default {
  name: 'DemanderSelector',

  componentName: 'DemanderSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    demanders: function demanders() {
      var _this = this;

      if (this.$store.getters.demander) {
        return this.$store.getters.demander.map(function (item) {
          return {
            value: isStringOrStringArray(_this.formValue[_this.innerConfig.prop]) ? String(item.id) : Number(item.id), // 兼容传入参数的类型
            label: item.real_name
          };
        });
      }
      return [];
    },
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: '请选择提需人'
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {
    if (this.demanders && !this.demanders.length) {
      this.$store.dispatch('GetDemander');
    }
  }
};